import { OrderVariantType } from 'types/order';

export const encodeLinkOrder = (id: string, variant: OrderVariantType) => {
  const encodedId = btoa(id); // Кодирование в Base64
  const encodeVariant = btoa(variant);
  return `${window.location.origin}/statistic/${encodedId}?v=${encodeVariant}`;
};
